import React from 'react';
import { useI18n } from '../../../../../data/hooks/i18nHooks';
import UserAvatar from '../../../../elements/icons/UserAvatar/UserAvatar';
import TopBarEvent from '../../../../elements/TopBar/TopBarEvent';
import UserName from '../../../../elements/UserName/UserName';
import UserProfileTabs from '../common/UserProfileTabs';
import styles from './UserProfileSpeakerHeader.module.scss';
import TopBarFavoriteParticipant from '../../TopBarFavoriteParticipant';
import altSpeakerAvatar from '../../../../../resources/icons/speaker_alt_avatar.png';

function UserProfileSpeakerHeader(props) {
    const { event, user, returnURL, inviteURL, canBeInvited, onPokeUser } = props,
        // headerIcons = [<TopBarFavoriteParticipant event={event} user={user} key="favorite" />],
        i18n = useI18n();

    return (
        <>
            <TopBarEvent event={event} returnURL={returnURL}>
                {i18n['label.contact.information']}
            </TopBarEvent>
            <hr />
            <UserAvatar className={styles.avatar} user={user} size={null} altSrc={altSpeakerAvatar} />
            <div className={['text-center', styles.profile].join(' ')}>
                <div className={[styles.name].join(' ')}>
                    <UserName user={user} />
                </div>
                {user.position ? <div className="text position">{user.position}</div> : null}
                {user.company ? <div className="text company">{user.company}</div> : null}
            </div>
            <UserProfileTabs event={event} user={user} isMe={false} canBeInvited={canBeInvited} inviteURL={inviteURL} onPokeUser={onPokeUser} />
        </>
    );
}

export default UserProfileSpeakerHeader;
